module.exports = __webpack_public_path__ + "img/voucherAdd.78b801db.png";